import { useEffect, useState } from 'react';
import { matchPath } from 'react-router-dom';
import { Paths, SEARCH_RESULTS_PROXY_PATHS } from '../../constants/paths';
import { usePrevLocationContext } from '../../context/PrevLocationContext';
export function useBackBreadcrumbLocation() {
  const prevLocation = usePrevLocationContext();
  const [backBreadcrumbLocation, setBackBreadcrumbLocation] = useState(prevLocation);
  useEffect(() => {
    if (!(prevLocation !== null && prevLocation !== void 0 && prevLocation.pathname)) {
      return;
    }
    const proxyPath = SEARCH_RESULTS_PROXY_PATHS.find(path => matchPath(prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.pathname, {
      path,
      exact: true
    }));
    if (proxyPath) {
      setBackBreadcrumbLocation(() => {
        switch (proxyPath) {
          case Paths.APPS_ALL:
          case Paths.APPS_ALL_PAGE:
          case Paths.APPS_CATEGORY:
          case Paths.APPS_CATEGORY_PAGE:
            return {
              pathname: Paths.APPS
            };
          case Paths.AGENTS_ALL:
          case Paths.AGENTS_ALL_PAGE:
          case Paths.AGENTS_TEAM:
          case Paths.AGENTS_TEAM_PAGE:
            return {
              pathname: Paths.AGENTS
            };
          case Paths.SEARCH_RESULTS_PAGE:
          default:
            return {
              pathname: Paths.HOME
            };
        }
      });
    }
  }, [prevLocation]);
  return backBreadcrumbLocation;
}